import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ReportingStatusForm from '../Forms/ReportingStatusForm';

const AddEditReportingStatusModal = ({
	dataReportingStatus,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Condición de Reportabilidad
			</ModalHeader>

			<ReportingStatusForm
				dataReportingStatus={dataReportingStatus}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditReportingStatusModal;
